import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const formatCurrency = (amount: number, currency: string) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(
    amount / 100,
  ); // Assuming the amount is in cents
};

const InvoiceDetails = ({ data }: any) => {
  const { invoiceDetails } = data;
  return (
    <Paper style={{ padding: '20px', margin: '20px 0' }}>
      <Typography variant="h6" style={{ marginBottom: '20px' }}>
        Invoice Preview
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell align="right">Amount</TableCell>
            {/* <TableCell align="right">Period Start</TableCell>
            <TableCell align="right">Period End</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {invoiceDetails.lines.data.map((line: any, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableRow key={`${index}`}>
              <TableCell>{line.description}</TableCell>
              <TableCell align="right">
                {formatCurrency(line.amount, invoiceDetails.currency)}
              </TableCell>
              {/* <TableCell align="right">
                {formatDate(line.period.start)}
              </TableCell>
              <TableCell align="right">{formatDate(line.period.end)}</TableCell> */}
            </TableRow>
          ))}
          <TableRow>
            <TableCell>Subtotal</TableCell>
            <TableCell align="right">
              {formatCurrency(invoiceDetails.subtotal, invoiceDetails.currency)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total</TableCell>
            <TableCell align="right">
              {formatCurrency(invoiceDetails.total, invoiceDetails.currency)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

export default InvoiceDetails;
